import axios from 'axios';

function headerConfig(contentType, auth) {
	const header = {};

	if (contentType && typeof contentType === 'string') {
		header['Content-Type'] = contentType;
	} else {
		header['Content-Type'] = 'application/json';
	}

	if (auth === true) {
		header.Authorization = 'Basic ' + new Buffer('admin:admin').toString('base64');
	}
	return header;
}

export default ({
	contentType,
	auth
}) => axios.create({
	baseURL: 'https://be-mockexam.leanwisdom.com:8443/leanwiz/rest',
	headers: headerConfig(contentType, auth)
});



// WEBPACK FOOTER //
// ./contexts/provider/ApiCall.js